import React,{ useEffect, useState } from "react";
import "./user.css";
import { useDispatch, useSelector } from 'react-redux';
import { fetchThemeData } from '../../admin/themeSlice';
import { useLocation } from "react-router-dom";

function USER({children }) {
  const dispatch = useDispatch();
    const location = useLocation();

    const {companyLogoUrl,backButtonUrl} = useSelector(state => state.ui);
    const [logoUrl,setLogoUrl]=useState("");
    const [backUrl,setBackUrl]=useState("");

    const { status, user, error } = useSelector(state => state.auth);
  const isMobileAppMode = user?.fromMobileApp === true;

  const navigateBackToHostApp = () => {
    if (!isMobileAppMode) return;
    window.GameStatus?.postMessage('navigate_back');
  };
    const { status: themeStatus, data: themeData } = useSelector(state => state.theme);
 

  const applyCustomTheme = (theme) => {
  if (!theme) return;

  document.documentElement.style.setProperty('--text-color', theme.text_color);
  document.documentElement.style.setProperty('--ui-color-1', theme.ui_color_1);
  document.documentElement.style.setProperty('--ui-color-2', theme.ui_color_2);
  document.documentElement.style.setProperty('--option-color', theme.option_color);
  document.documentElement.style.setProperty('--option-text-color', theme.option_text_color);
};
    
  useEffect(() => {
      if (!/^\/login(?:\/)?$/.test(location.pathname)) {
        console.log("only /login");
        if (themeStatus === "idle") {
          dispatch(fetchThemeData({ themeId: null }));
        }
      }
  }, [themeStatus, dispatch]);

  useEffect(()=>{
    console.log(backButtonUrl);
    console.log(companyLogoUrl);
    setBackUrl(backButtonUrl);
    setLogoUrl(companyLogoUrl);
  },[backButtonUrl,companyLogoUrl])


  useEffect(() => {
    if (themeStatus !== "succeeded" || !themeData) return;

    applyCustomTheme(themeData.colors);

    const body = document.body;

    // Rules page uses body.common-bg.rules-page-bg in index.css; clear theme inline bg so CSS wins.
    if (/^\/rules\/?$/.test(location.pathname)) {
      body.style.backgroundImage = "";
      return;
    }
    const bg =
      window.innerWidth <= 768 ? themeData.background_mob : themeData.background_desk;
    if (body.classList.contains("common-bg")) {
      body.style.backgroundImage = `url(${process.env.REACT_APP_S3_PATH + bg})`;
    }
  }, [themeStatus, themeData, location.pathname]);


  return (
    <>
      <header className="upperaction">
      {isMobileAppMode ? (
        <button
          type="button"
          onClick={navigateBackToHostApp}
          className="logo-holder"
          style={{ background: "transparent", border: 0, padding: 0, cursor: "pointer" }}
        >
          <img src={logoUrl} className="logo-holder" />
        </button>
      ) : (
        <a href={process.env.REACT_APP_BASE_URL}><img src={logoUrl} className="logo-holder" /></a>
      )}
        {!isMobileAppMode ? (
          <div className="back-holder">
         <a href={backUrl}><button className="back-default">Back</button></a> 
          </div>
        ) : null}
       
      </header>
      {children}
    </>
  );
}

export default USER;
